/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import { useDispatch } from "react-redux";
import { handleEditOpen, rowValue } from "../../../redux/Reducer/ModalSlice";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style";
import {
  ButtonGroup,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import TableFilter from "../../table-components/filter/TableFilter";
import TableComp from "../../table-components/table/TableComp";
import Pagination from "../../table-components/pagination/Pagination";
import AddModal from "../../modal/AddModal";
import AddMenu from "./AddMenu";
import EditModal from "../../modal/EditModal";
import EditMenu from "./EditMenu";

const MenuTable = ({ data, refetch }) => {
  const dispatch = useDispatch();

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "module_id",
        // Cell: (row) => {
        //   return <div>{Number(row.row.id) + 1}</div>;
        // },
        Filter: false,
      },
      {
        Header: "Menu Name",
        accessor: "module_name",
        Filter: false,
      },
      {
        Header: "Menu Route",
        accessor: "menu_route",
        Filter: false,
      },
      {
        Header: "Active Status",
        accessor: "active_fg",
        Filter: false,
        Cell: (e) => (
          <div
            style={{
              marginLeft: "10Px",
            }}
          >
            {e.value === "Y" ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Action
          </div>
        ),
        accessor: "col3",
        Cell: (row) => (
          <ButtonGroup
          // style={{
          //   display: "flex",
          //   justifyContent: "center",
          // }}
          >
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              // style={{}}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add Module"
        />
      </div>

      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {/* {isLoading && (
    <div
      style={
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "280px",
        }
        // display:"flex",
      }
    >
      <CircularProgress />
    </div>
  )} */}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
      <AddModal ModalWidth="sm" ModalTitle="Add Module Name">
        <AddMenu refetch={refetch} />
      </AddModal>
      <EditModal ModalWidth="sm" ModalTitle="Edit Module Information">
        <EditMenu refetch={refetch} />
      </EditModal>
    </>
  );
};

export default MenuTable;
